import { render, staticRenderFns } from "./RoomInfoPC.vue?vue&type=template&id=158a66ab&scoped=true"
import script from "./RoomInfoPC.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoomInfoPC.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RoomInfoPC.vue?vue&type=style&index=0&id=158a66ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158a66ab",
  null
  
)

export default component.exports